<template>
  <svg
    xmlns:dc="http://purl.org/dc/elements/1.1/"
    xmlns:cc="http://creativecommons.org/ns#"
    xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#"
    xmlns:svg="http://www.w3.org/2000/svg"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:sodipodi="http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd"
    xmlns:inkscape="http://www.inkscape.org/namespaces/inkscape"
    version="1.1"
    id="svg10"
    width="190"
    viewBox="0 0 240 237"
    sodipodi:docname="ups.svg"
    inkscape:version="1.0.1 (3bc2e813f5, 2020-09-07)"
  >
    <metadata id="metadata16">
      <rdf:RDF>
        <cc:Work rdf:about="">
          <dc:format>image/svg+xml</dc:format>
          <dc:type rdf:resource="http://purl.org/dc/dcmitype/StillImage" />
          <dc:title />
        </cc:Work>
      </rdf:RDF>
    </metadata>
    <defs id="defs14" />
    <sodipodi:namedview
      pagecolor="#ffffff"
      bordercolor="#666666"
      borderopacity="1"
      objecttolerance="10"
      gridtolerance="10"
      guidetolerance="10"
      inkscape:pageopacity="0"
      inkscape:pageshadow="2"
      inkscape:window-width="1366"
      inkscape:window-height="705"
      id="namedview12"
      showgrid="false"
      inkscape:snap-global="true"
      inkscape:zoom="1.9152154"
      inkscape:cx="202.03264"
      inkscape:cy="111.02452"
      inkscape:window-x="-8"
      inkscape:window-y="-8"
      inkscape:window-maximized="1"
      inkscape:current-layer="g18"
      inkscape:document-rotation="0"
    />
    <g inkscape:groupmode="layer" inkscape:label="Image" id="g18">
      <!-- <path
       id="path900-3-8"
       style="font-variation-settings:normal;opacity:1;vector-effect:none;fill:#4ca141;fill-opacity:1;fill-rule:evenodd;stroke:none;stroke-width:2.36068;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:17.1;stroke-dasharray:none;stroke-dashoffset:0;stroke-opacity:1;paint-order:markers stroke fill;stop-color:#000000;stop-opacity:1"
       d="M 21.074863,61.536457 A 114.61272,114.61272 0 0 1 119.6309,3.7139667 114.61272,114.61272 0 0 1 219.18108,59.807617 l -98.55001,58.514713 z"
       inkscape:transform-center-x="0.46019417"
       inkscape:transform-center-y="-57.064078" 
       transform=""/> -->
      <circle
        style="
          font-variation-settings: normal;
          opacity: 1;
          vector-effect: none;
          fill: #eceff1;
          fill-opacity: 1;
          fill-rule: evenodd;
          stroke: #000000;
          stroke-width: 2.36068;
          stroke-linecap: round;
          stroke-linejoin: round;
          stroke-miterlimit: 17.1;
          stroke-dasharray: none;
          stroke-dashoffset: 0;
          stroke-opacity: 1;
          paint-order: markers stroke fill;
          stop-color: #000000;
          stop-opacity: 1;
        "
        id="path900"
        cx="120.69353"
        cy="118.87598"
        r="114.61272"
      />
      <path
        ref="loadPercentage"
        id="loadPercentage"
        fill="none"
        stroke="#4CA141"
        stroke-width="30"
        :d="loadPercentageAngle"
      />
      <circle
        style="
          font-variation-settings: normal;
          opacity: 1;
          vector-effect: none;
          fill: none;
          fill-opacity: 1;
          fill-rule: evenodd;
          stroke: #000000;
          stroke-width: 2.36068;
          stroke-linecap: round;
          stroke-linejoin: round;
          stroke-miterlimit: 17.1;
          stroke-dasharray: none;
          stroke-dashoffset: 0;
          stroke-opacity: 1;
          paint-order: markers stroke fill;
          stop-color: #000000;
          stop-opacity: 1;
        "
        id="path900"
        cx="120.69353"
        cy="118.87598"
        r="114.61272"
      />

      <!-- <path
       :id="idLoad2"
       fill="none"
       stroke="#4CA141"
       stroke-width="30" /> -->
      <!-- <path
       style="font-variation-settings:normal;opacity:1;vector-effect:none;fill:#e0e0e0;fill-opacity:1;fill-rule:evenodd;stroke:none;stroke-width:2.36068;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:17.1;stroke-dasharray:none;stroke-dashoffset:0;stroke-opacity:1;paint-order:markers stroke fill;stop-color:#000000;stop-opacity:1"
       id="path900-3"
       sodipodi:type="arc"
       sodipodi:cx="120.63107"
       sodipodi:cy="118.32233"
       sodipodi:rx="114.61272"
       sodipodi:ry="114.61272"
       sodipodi:start="0.49916417"
       sodipodi:end="2.6424285"
       sodipodi:arc-type="slice"
       d="M 221.25909,173.1865 A 114.61272,114.61272 0 0 1 120.63107,232.93504 114.61272,114.61272 0 0 1 20.003058,173.1865 L 120.63107,118.32233 Z" /> -->
      <g id="g2043" transform="translate(286,18)">
        <path
          style="
            fill: none;
            stroke: #000000;
            stroke-width: 1.521;
            stroke-linecap: butt;
            stroke-linejoin: miter;
            stroke-miterlimit: 4;
            stroke-dasharray: none;
            stroke-opacity: 1;
          "
          d="m -167.05013,-3.4209507 1.84006,207.7476207"
          id="path1999"
        />
        <path
          style="
            fill: none;
            stroke: #000000;
            stroke-width: 1.52944;
            stroke-linecap: butt;
            stroke-linejoin: miter;
            stroke-miterlimit: 4;
            stroke-dasharray: none;
            stroke-opacity: 1;
          "
          d="M -219.7134,189.7401 -112.45853,11.164645"
          id="path1999-4"
        />
        <path
          style="
            fill: none;
            stroke: #000000;
            stroke-width: 1.52944;
            stroke-linecap: butt;
            stroke-linejoin: miter;
            stroke-miterlimit: 4;
            stroke-dasharray: none;
            stroke-opacity: 1;
          "
          d="M -112.45853,189.7401 -219.7134,11.16464"
          id="path1999-4-3"
        />
      </g>
      <circle
        style="
          font-variation-settings: normal;
          opacity: 1;
          vector-effect: none;
          fill: #343434;
          fill-opacity: 1;
          fill-rule: evenodd;
          stroke: #000000;
          stroke-width: 2.5;
          stroke-linecap: round;
          stroke-linejoin: round;
          stroke-miterlimit: 17.1;
          stroke-dasharray: none;
          stroke-dashoffset: 0;
          stroke-opacity: 1;
          paint-order: markers stroke fill;
          stop-color: #000000;
          stop-opacity: 1;
        "
        id="path900-4"
        cx="120.69353"
        cy="118.87598"
        r="90.456009"
      />
      <path
        style="
          fill: #ffffff;
          fill-opacity: 1;
          stroke: #000000;
          stroke-width: 2;
          stroke-linecap: butt;
          stroke-linejoin: miter;
          stroke-miterlimit: 4;
          stroke-dasharray: none;
          stroke-opacity: 1;
        "
        d="m 22.05891,60.412454 28.34684,23.319643 h 139.92476 l 28.37408,-23.72347 c 17.80002,27.351383 15.61405,47.457643 16.07181,45.397683 1.39816,19.24136 0.0295,24.345 -0.84143,36.24813 -4.12916,12.66893 -5.84476,23.64112 -15.42889,37.17529 L 189.02889,150.11501 H 50.40575 L 23.07161,179.40159 C 14.97905,169.08333 8.69555,152.42064 6.61067,134.79778 5.31873,119.7136 5.98321,105.9337 8.37249,93.303671 10.885,82.458284 15.944734,70.893418 22.05891,60.412454 Z"
        id="path1478"
        sodipodi:nodetypes="ccccccccccccc"
      />
      <circle
        style="
          font-variation-settings: normal;
          opacity: 1;
          vector-effect: none;
          fill: none;
          fill-opacity: 1;
          fill-rule: evenodd;
          stroke: #000000;
          stroke-width: 2.5;
          stroke-linecap: round;
          stroke-linejoin: round;
          stroke-miterlimit: 17.1;
          stroke-dasharray: none;
          stroke-dashoffset: 0;
          stroke-opacity: 1;
          paint-order: markers stroke fill;
          stop-color: #000000;
          stop-opacity: 1;
        "
        id="path900-4-7"
        cx="121.25049"
        cy="118.78252"
        r="90.456009"
      />
      <text
        xml:space="preserve"
        style="
          font-style: normal;
          font-weight: normal;
          font-size: 24px;
          line-height: 1.25;
          font-family: sans-serif;
          fill: #000000;
          fill-opacity: 1;
          stroke: none;
        "
        x="85.957314"
        y="56.372818"
        id="text1628"
      >
        <tspan
          sodipodi:role="line"
          id="tspan1626"
          x="43%"
          y="56.372818"
          style="font-size: 24px; fill: #ffffff;"
        >
          {{ Math.round((data.load / 32) * 100) }}%
        </tspan>
      </text>
      <text
        xml:space="preserve"
        style="
          font-style: normal;
          font-variant: normal;
          font-weight: normal;
          font-stretch: normal;
          font-size: 18.6667px;
          line-height: 1.25;
          font-family: sans-serif;
          font-variant-ligatures: normal;
          font-variant-position: normal;
          font-variant-caps: normal;
          font-variant-numeric: normal;
          font-variant-alternates: normal;
          font-variant-east-asian: normal;
          font-feature-settings: normal;
          font-variation-settings: normal;
          text-indent: 0;
          text-align: start;
          text-decoration: none;
          text-decoration-line: none;
          text-decoration-style: solid;
          text-decoration-color: #000000;
          letter-spacing: normal;
          word-spacing: normal;
          text-transform: none;
          writing-mode: lr-tb;
          direction: ltr;
          text-orientation: mixed;
          dominant-baseline: auto;
          baseline-shift: baseline;
          text-anchor: start;
          white-space: normal;
          shape-padding: 0;
          shape-margin: 0;
          inline-size: 0;
          opacity: 1;
          vector-effect: none;
          fill: #ffffff;
          fill-opacity: 1;
          stroke: none;
          stroke-width: 1;
          stroke-linecap: butt;
          stroke-linejoin: miter;
          stroke-miterlimit: 4;
          stroke-dasharray: none;
          stroke-dashoffset: 0;
          stroke-opacity: 1;
          stop-color: #000000;
          stop-opacity: 1;
        "
        x="-223.62137"
        y="61.770874"
        id="text1632"
        transform="translate(286,16)"
      >
        <tspan
          sodipodi:role="line"
          id="tspan1630"
          x="-218.62137"
          y="61.770874"
          style="
            font-style: normal;
            font-variant: normal;
            font-weight: normal;
            font-stretch: normal;
            font-size: 18.6667px;
            line-height: 1.25;
            font-family: sans-serif;
            font-variant-ligatures: normal;
            font-variant-position: normal;
            font-variant-caps: normal;
            font-variant-numeric: normal;
            font-variant-alternates: normal;
            font-variant-east-asian: normal;
            font-feature-settings: normal;
            font-variation-settings: normal;
            text-indent: 0;
            text-align: start;
            text-decoration: none;
            text-decoration-line: none;
            text-decoration-style: solid;
            text-decoration-color: #000000;
            letter-spacing: normal;
            word-spacing: normal;
            text-transform: none;
            writing-mode: lr-tb;
            direction: ltr;
            text-orientation: mixed;
            dominant-baseline: auto;
            baseline-shift: baseline;
            text-anchor: start;
            white-space: normal;
            shape-padding: 0;
            shape-margin: 0;
            inline-size: 0;
            vector-effect: none;
            fill: #ffffff;
            fill-opacity: 1;
            stroke: none;
            stroke-width: 1;
            stroke-linecap: butt;
            stroke-linejoin: miter;
            stroke-miterlimit: 4;
            stroke-dasharray: none;
            stroke-dashoffset: 0;
            stroke-opacity: 1;
            stop-color: #000000;
            stop-opacity: 1;
          "
        >
          Load: {{ data.load }} kW
        </tspan>
      </text>
      <text
        xml:space="preserve"
        style="
          font-style: normal;
          font-variant: normal;
          font-weight: normal;
          font-stretch: normal;
          font-size: 18.6667px;
          line-height: 1.25;
          font-family: sans-serif;
          font-variant-ligatures: normal;
          font-variant-position: normal;
          font-variant-caps: normal;
          font-variant-numeric: normal;
          font-variant-alternates: normal;
          font-variant-east-asian: normal;
          font-feature-settings: normal;
          font-variation-settings: normal;
          text-indent: 0;
          text-align: start;
          text-decoration: none;
          text-decoration-line: none;
          text-decoration-style: solid;
          text-decoration-color: #000000;
          letter-spacing: normal;
          word-spacing: normal;
          text-transform: none;
          writing-mode: lr-tb;
          direction: ltr;
          text-orientation: mixed;
          dominant-baseline: auto;
          baseline-shift: baseline;
          text-anchor: start;
          white-space: normal;
          shape-padding: 0;
          shape-margin: 0;
          inline-size: 0;
          opacity: 1;
          vector-effect: none;
          fill: #ffffff;
          fill-opacity: 1;
          stroke: none;
          stroke-width: 1;
          stroke-linecap: butt;
          stroke-linejoin: miter;
          stroke-miterlimit: 4;
          stroke-dasharray: none;
          stroke-dashoffset: 0;
          stroke-opacity: 1;
          stop-color: #000000;
          stop-opacity: 1;
        "
        x="-223.62137"
        y="61.770874"
        id="text1632-0"
        transform="translate(286,108)"
      >
        <tspan
          sodipodi:role="line"
          id="tspan1630-9"
          x="-218.62137"
          y="68.770874"
          style="
            font-style: normal;
            font-variant: normal;
            font-weight: normal;
            font-stretch: normal;
            font-size: 18.6667px;
            line-height: 1.25;
            font-family: sans-serif;
            font-variant-ligatures: normal;
            font-variant-position: normal;
            font-variant-caps: normal;
            font-variant-numeric: normal;
            font-variant-alternates: normal;
            font-variant-east-asian: normal;
            font-feature-settings: normal;
            font-variation-settings: normal;
            text-indent: 0;
            text-align: start;
            text-decoration: none;
            text-decoration-line: none;
            text-decoration-style: solid;
            text-decoration-color: #000000;
            letter-spacing: normal;
            word-spacing: normal;
            text-transform: none;
            writing-mode: lr-tb;
            direction: ltr;
            text-orientation: mixed;
            dominant-baseline: auto;
            baseline-shift: baseline;
            text-anchor: start;
            white-space: normal;
            shape-padding: 0;
            shape-margin: 0;
            inline-size: 0;
            vector-effect: none;
            fill: #ffffff;
            fill-opacity: 1;
            stroke: none;
            stroke-width: 1;
            stroke-linecap: butt;
            stroke-linejoin: miter;
            stroke-miterlimit: 4;
            stroke-dasharray: none;
            stroke-dashoffset: 0;
            stroke-opacity: 1;
            stop-color: #000000;
            stop-opacity: 1;
          "
        >
          Batt: {{ data.battery }} min
        </tspan>
      </text>
      <text
        xml:space="preserve"
        style="
          font-style: normal;
          font-weight: normal;
          font-size: 17.3333px;
          line-height: 1.25;
          font-family: sans-serif;
          fill: #000000;
          fill-opacity: 1;
          stroke: none;
        "
        x="50.478233"
        y="100.87941"
        id="text1796"
      >
        <tspan
          sodipodi:role="line"
          id="tspan1794"
          x="50.478233"
          y="110.87941"
          style="font-size: 17.3333px;"
        >
          Input:
        </tspan>
        <tspan
          sodipodi:role="line"
          x="50.478233"
          y="132.54604"
          id="tspan1798"
          style="font-size: 17.3333px;"
        >
          Output:
        </tspan>
        <tspan
          sodipodi:role="line"
          x="50.478233"
          y="144.21266"
          id="tspan1800"
          style="font-size: 17.3333px;"
        ></tspan>
      </text>
      <!-- <text
       xml:space="preserve"
       style="font-style:normal;font-weight:normal;font-size:24px;line-height:1.25;font-family:sans-serif;fill:#000000;fill-opacity:1;stroke:none"
       x="84.258263"
       y="197.59415"
       id="text1628-8"><tspan
         sodipodi:role="line"
         id="tspan1626-5"
         x="45%"
         y="197.59415"
         style="font-size:24px;fill:#ffffff">-%</tspan></text> -->
      <text
        xml:space="preserve"
        style="
          font-style: normal;
          font-weight: normal;
          font-size: 17.3333px;
          line-height: 1.25;
          font-family: sans-serif;
          fill: #000000;
          fill-opacity: 1;
          stroke: none;
        "
        x="154.84143"
        y="100.87941"
        id="text1796-4"
      >
        <tspan
          sodipodi:role="line"
          x="154.84143"
          y="110.87941"
          id="tspan1800-1"
          style="font-size: 17.3333px;"
        >
          {{ data.input }}
        </tspan>
        <tspan
          sodipodi:role="line"
          x="154.84143"
          y="132.54604"
          style="font-size: 17.3333px;"
          id="tspan152"
        >
          {{ data.output }}
        </tspan>
        <tspan
          sodipodi:role="line"
          x="154.84143"
          y="144.21266"
          style="font-size: 17.3333px;"
          id="tspan154"
          class="hidden"
        >
          {{ data.bypass }}
        </tspan>
      </text>
    </g>
  </svg>
</template>

<script>
export default {
  props: {
    data: {
      type: Object,
      default: () => {}
    }
  },
  computed: {
    iniapa() {
      return 'ini bukan apa apa'
    },
    loadPercentageAngle() {
      // it's 120 because round starts from -60 to 60
      const loadPercentage = Math.round((this.data.load / 32) * 100)
      const loadEndAngle = 120 / (100 / loadPercentage) - 60
      const loadPercentageAngle = this.describeArc(
        120,
        120,
        100,
        -60,
        loadEndAngle
      )
      return loadPercentageAngle
    }
  },
  methods: {
    polarToCartesian(centerX, centerY, radius, angleInDegrees) {
      const angleInRadians = ((angleInDegrees - 90) * Math.PI) / 180.0

      return {
        x: centerX + radius * Math.cos(angleInRadians),
        y: centerY + radius * Math.sin(angleInRadians)
      }
    },
    describeArc(x, y, radius, startAngle, endAngle) {
      var start = this.polarToCartesian(x, y, radius, endAngle)
      var end = this.polarToCartesian(x, y, radius, startAngle)

      var largeArcFlag = endAngle - startAngle <= 180 ? '0' : '1'

      var d = [
        'M',
        start.x,
        start.y,
        'A',
        radius,
        radius,
        0,
        largeArcFlag,
        0,
        end.x,
        end.y
      ].join(' ')

      return d
    }
  }
}
</script>
